<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Pipeline conversions') }}</h4>
        </div>
        <div>
          <div class="form-inline">
            <div class="form-group mr-2">
              <range-date-filter
                :value="rangeDate"
                @input="(v) => { setFilters({created_at: v}) }"
                style="min-width: 210px"> 
                </range-date-filter>
            </div>
            <button
              class="btn btn-light"
              @click="exportReport">
              {{ $t('Export xlsx') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">

        <Paginaty
          :total="grid.length"
          :pages="0"
          :page="0"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content">
            <div class="p-3" style="width: 100%; overflow: hidden;">
              <highcharts
                :options="chartOptions">
                </highcharts>
            </div>
            <div style="height: 100%; overflow-x: scroll;">
              <table class="table table-bordered">
                <thead class="thead-fixed">
                  <tr>
                    <th-sort field="stage_position" :value="sort" @input="setSort">Posição</th-sort>
                    <th-sort field="name" :value="sort" @input="setSort">{{ $t('Stage') }}</th-sort>
                    <th-sort field="total_movements" :value="sort" @input="setSort">{{ $t('Candidates') }}</th-sort>
                    <th-sort field="total_moved" :value="sort" @input="setSort">Movidos</th-sort>
                    <th-sort field="avg_conversion" :value="sort" @input="setSort">Conversões</th-sort>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in grid">
                    <th class="text-truncate">{{ item.stage_position }}</th>
                    <th class="text-truncate">{{ item.name }}</th>
                    <td class="text-truncate">{{ item.total_movements }}</td>
                    <td class="text-truncate">{{ item.total_moved }}</td>
                    <td class="text-truncate">{{ item.avg_conversion }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </filterfy>
    </div>

  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'
import Filterfy from '@/components/Filterfy/Filterfy'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import RangeDateFilter from './RangeDateFilter'
import BlobDownload from '@/utils/BlobDownload'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import moment from 'moment'

export default {
  name: 'ReportPipelineSpeed',
  components: {
    highcharts: Chart,
    Filterfy,
    ThSort,
    Paginaty,
    RangeDateFilter
  },
  data () {
    return {
      creating: true,
      loading: true,
      filtersMap: [
        {
          'type': 'list',
          'label': this.$t('Company'),
          'target': 'job.company_id',
          'resource': 'companies'
        },
        {
          'type': 'list',
          'label': this.$t('Department'),
          'target': 'job.departament_id',
          'resource': 'departaments'
        }
      ],
      grid: false
    }
  },
  computed: {
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || 'stage_position'
    },
    rangeDate () {
      const defaultDate = `d|${moment().subtract(30, 'days').toISOString()}|${moment().toISOString()}`
      return this.$route.query.created_at === undefined ? defaultDate : this.$route.query.created_at
    },
    chartOptions () {
      return {
        chart: {
          type: 'column'
        },
        lang: {
          noData: this.$t('No data to display')
        },
        title: {
          text: this.$t('Pipeline conversions')
        },
        xAxis: {
          // categories: ['Candidatura <b>22%</b>', 'Triagem <b>40%</b>']
          categories: this.grid.map(v => v.name)
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('Candidates')
          },
          stackLabels: {
            enabled: true
          }
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>-<br/><span>Entraram</span>:<b>{point.total}</b><br/>',
          pointFormat: ` <span style="color:{series.color}">{series.name}</span>:<b>{point.y}</b> ({point.percentage:.1f}%)<br/>`,
          shared: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            stacking: 'stream',
            dataLabels: {
              enabled: true,
              color: '#5cb84a',
              verticalAlign: 'bottom',
              align: 'right',
              x: 45,
              formatter: function () {
                if (this.point.series.name === 'Permaneceram') {
                  return null // this.point.options.y
                } else {
                  const perc = this.point.options.y / this.point.total * 100
                  return `${perc.toFixed(1)}%`
                }
              }
            }
          }
        },
        /* series: [{
          name: 'Permaneceram',
          color: 'black',
          data: [5, 3, 4, 7, 2]
        }, {
          name: 'Avançaram',
          color: 'green',
          data: [2, 2, 3, 2, 1]
        }] */
        series: [{
          name: 'Permaneceram',
          color: '#434348',
          data: this.grid.map(v => v.total_movements - v.total_moved)
        }, {
          name: 'Saíram',
          color: '#5cb84a',
          data: this.grid.map(v => v.total_moved)
        }]
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        created_at: this.rangeDate,
        page: this.$route.query.page || 1,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/pipeline-conversion', {params: params})
      .then((response) => {
        this.grid = response.data
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    exportReport () {
      const params = {
        ...this.filters,
        sort: this.sort
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/pipeline-conversion/export', {params: params, responseType: 'blob', timeout: 30000})
      .then((response) => {
        BlobDownload(response)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/ReportPipelineConversion.vue